export default __webpack_public_path__ + "static/media/hand-translation.eea2abc4.png";